<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row" v-if="!admin.tenantId">
        <Select v-model="params.tenantId" placeholder="加盟商" clearable style="width:200px">
          <Option v-for="(item, index) in tenantList" :value="item.tenantId" :key="index">{{ item.companyName }}</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <Select v-model="params.type" placeholder="投诉及意见类型" clearable style="width:200px">
          <Option value="">全部</Option>
          <Option value="1">意见反馈</Option>
          <Option value="2">投诉反馈</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                    separator=" ~ " split-panels transfer
                    placeholder="创建时间" style="width: 200px"></DatePicker>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>投诉及意见列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
              <!-- <Button @click="showfeedbackOpe(2)">新增投诉及意见</Button> -->
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

        <template slot-scope="{ row, index }" slot="userName">
          <span v-if="row.userName">{{ row.userName }}</span>
          <span v-if="!row.userName">-</span>
        </template>

        <template slot-scope="{ row, index }" slot="phone">
          <span v-if="row.phone">{{ row.phone }}</span>
          <span v-if="!row.phone">-</span>
        </template>

        <template slot-scope="{ row, index }" slot="type">
          <span v-if="row.type == 1">意见反馈</span>
          <span v-if="row.type == 2">投诉反馈</span>
        </template>

        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" @click="showfeedbackOpe(1, row)">查看
          </Button>
          <Button type="error" size="small" style="margin-right: 5px" @click="isDel(row)">删除
          </Button>
          <Button type="success" size="small" style="margin-right: 5px" @click="toUserOrderPage(row)">查看订单
          </Button>
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <!--显示模态框-->
    <feedback-ope ref="feedbackOpe" @changeDate="findList"></feedback-ope>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import feedbackOpe from './components/feedback-ope';

export default {
  data() {
    return {
      admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
      total: 0,
      dateInit: '',
      isTableLoading: false,
      // 参数
      params: {
        page: 1,
        rows: 10,
        type: '',
        startTime: '',
        endTime: '',
        tenantId: ''
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          minWidth: 120,
          key: 'feedbackId'
        },
        {
          title: '用户称呼',
          minWidth: 280,
          slot: 'userName'
        },
        {
          title: '用户手机号',
          minWidth: 120,
          slot: 'phone'
        },
        {
          title: '类型',
          minWidth: 120,
          slot: 'type'
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 150
        },
        {
          title: '操作',
          slot: 'action',
          width: 250,
          align: 'center'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '用户管理', url: '', icon: '', size: 0},
        {name: '投诉及意见列表', url: '', icon: '', size: 0}
      ],
      tenantList: []
    }
  },
  created() {
    // 租户-列表查询
    this.findTenantAll();
    // 投诉及意见-列表查询
    // this.findList();
  },
  methods: {
    // 租户查询
    findTenantAll() {
      this.axios.post('/tenant/findAll').then(res => {
        if (res.status == 200) {
          this.tenantList = res.data;
          if (!this.admin.tenantId) {
            this.params.tenantId = this.tenantList[0].tenantId
          }
          this.findList();
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询加盟商列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 投诉及意见-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/feedback/findFeedback', this.params).then(res => {
        console.log(res);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询投诉及意见列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 是否删除投诉及意见
    isDel(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否删除？`,
        onOk: () => {
          // this.$Message.info('您点击了确定.');
          this.deleteFeedback(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 删除投诉及意见
    deleteFeedback(row) {
      this.$Spin.show();
      this.axios.post('/feedback/deleteFeedback', {
        feedbackId: row.feedbackId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findList();
        }
        if (res.status == 201) {
          // this.$Message.error(res.msg);
          this.$Notice.error({
            title: '删除投诉及意见失败',
            desc: res.msg
          });
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '删除投诉及意见接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showfeedbackOpe(type, row) {
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      this.$refs.feedbackOpe.show(type, row);
    },
    // 显示操作模态框
    toUserOrderPage(row) {
      this.$router.push({path: '/index/recovery-order',query:{
          userId: row.userId
        }})
    },
    // 重置筛选条件
    resetScreen() {
      this.params.page = 1;
      this.params.type = '';
      this.params.startTime = '';
      this.params.endTime = '';
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
  },
  components: {
    hsBreadcrumb,
    feedbackOpe
  }
}
</script>

<style scoped>

</style>